import React, { useEffect, useState } from "react";
import appleIcon from "../../assets/images/svg/appleIcon.svg";
import androidIcon from "../../assets/images/svg/androidIcon.svg";
import otherDeviceIcon from "../../assets/images/svg/otherDeviceIcon.svg";
import disableIcon from "../../assets/images/svg/disableIcon.svg";
import recentLoginIcon from "../../assets/images/svg/recentLoginIcon.svg";
import filterIcon from "../../assets/images/svg/filterIcon.svg";
import viewMoreIcon from "../../assets/images/svg/viewMoreIcon.svg";
import rightArrowWhite from "../../assets/images/svg/rightArrowWhite.svg";
import Modal from "../Modal";
import { Observer } from "mobx-react-lite";
import EmptyDerivatives from "../EmptyDerivaties/EmptyDerivaties";
import emptyIcon from "../../assets/images/svg/empty.svg";
import AuthStore from "../../store/AuthStore";
import SettingsStore from "../../store/SettingsStore";
import loaderGIF from "../../assets/images/gifs/loaderGIF.gif";
import UserStore from "../../store/UserStore";
import { familyOfficeTeamNameText } from "../../utils/constants";

const ManageDevices = () => {
  const [openModal, setOpenModal] = useState(false);
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [selectedDeviceForRemove, setSelectedDeviceForRemove] = useState(null);
  const [recentLoginArrLength, setRecentLoginArrLength] = useState(5);
  const [tempLoginFromCheckedIds, setTempLoginFromCheckedIds] = useState(
    SettingsStore.loginFromCheckedIds
  );
  const [tempbyDevicesFilterSelected, setTempbyDevicesFilterSelected] =
    useState(SettingsStore.byDevicesFilterSelected);
  const [isFilteredDataHasLength, setIsFilteredDataHasLength] = useState(false);
  const [filteredArrayTotalLen, setFilteredArrayTotalLen] = useState(null);
  const [viewMoreClicked, setViewMoreClicked] = useState(false);
  const [flag, setFlag] = useState(false);

  const recentLogin = SettingsStore.recentLogin;

  useEffect(() => {
    if (flag) {
      let tempFilters = [];
      SettingsStore.recentLogin?.forEach((eachLogin) => {
        if (
          !tempFilters?.find(
            (item) => item.user.user_id === eachLogin.user.user_id
          )
        ) {
          tempFilters.push(eachLogin);
          SettingsStore.updateLoginFromCheckedIds({
            [eachLogin.user.user_id]: true,
          });
          setTempLoginFromCheckedIds((prev) => {
            return { ...prev, [eachLogin.user.user_id]: true };
          });
        }
      });
      SettingsStore.updateLoginFromUserList(tempFilters);
    }
  }, [recentLogin, flag]);

  useEffect(() => {
    setTimeout(() => {
      setFlag(true);
    }, 2);
    return () => {
      setFlag(false);
    };
  }, []);

  const DisableDeviceModalContent = () => {
    const handleRemove = () => {
      window.scrollTo(0, 0);
      AuthStore.updateLoadingFullScreen(true);
      SettingsStore.callDeleteRegisteredDevice(
        selectedDeviceForRemove?.deviceId
      );
      setOpenModal(false);
    };
    return (
      <Observer>
        {() => (
          <div className="disable_device_container">
            <div className="device_icon_wrapper">
              <img
                src={getIcon(selectedDeviceForRemove?.deviceType)}
                alt="apple"
              />
            </div>
            <p className="remove_device_text">
              Remove {selectedDeviceForRemove?.deviceBuild}?
            </p>
            <p className="remove_device_subtext">
              {selectedDeviceForRemove?.deviceType === "Android" ||
              selectedDeviceForRemove?.deviceType === "iOS"
                ? `To add this device back, you will have to set up your MPIN again
              in your mobile device`
                : `To add this browser again please login again from the same`}
            </p>
            <div className="bottom_navigation">
              <button
                className="cencel_btn"
                onClick={() => setOpenModal(false)}
              >
                Cancel
              </button>
              <div className="remove_btn">
                <p onClick={handleRemove}> Yes, Remove</p>
                <button className="arrow_red_btn" onClick={handleRemove}>
                  <div className="arrow_btn">
                    <svg
                      width="10"
                      height="16"
                      viewBox="0 0 10 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1.88 16L0 14.12L6.10667 8L0 1.88L1.88 -4.76837e-07L9.88 8L1.88 16Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                </button>
              </div>
            </div>
          </div>
        )}
      </Observer>
    );
  };

  const FilterModalContent = () => {
    const handleUserSelection = (userId, checked) => {
      setTempLoginFromCheckedIds({
        ...tempLoginFromCheckedIds,
        [userId]: !checked,
      });
    };

    const handleReset = () => {
      setTempbyDevicesFilterSelected({
        apple: true,
        android: true,
        others: true,
      });
      const tempCheckIds = tempLoginFromCheckedIds;
      for (let index in tempCheckIds) {
        tempCheckIds[index] = true;
      }
      setTempLoginFromCheckedIds(tempCheckIds);
      SettingsStore.resetFilter();
    };

    const handleApplyFilter = () => {
      setViewMoreClicked(false);
      SettingsStore.updateLoginFromCheckedIds(tempLoginFromCheckedIds);
      SettingsStore.updatebyDevicesFilterSelected(tempbyDevicesFilterSelected);
      setOpenFilterModal(false);
    };

    const handleDeviceSelection = (updatedState, deviceType) => {
      if (
        !updatedState.apple &&
        !updatedState.android &&
        !updatedState.others
      ) {
        if (deviceType === "apple") {
          setTempbyDevicesFilterSelected({
            apple: false,
            android: true,
            others: false,
          });
        } else if (deviceType === "android") {
          setTempbyDevicesFilterSelected({
            apple: false,
            android: false,
            others: true,
          });
        } else if (deviceType === "others") {
          setTempbyDevicesFilterSelected({
            apple: true,
            android: false,
            others: false,
          });
        }
      } else {
        setTempbyDevicesFilterSelected(updatedState);
      }
    };
    return (
      <Observer>
        {() => (
          <div className="filter_container">
            <div className="logins_from_container">
              <p className="logins_from_text">Logins from</p>
              <div className="username_details_wrapper">
                {SettingsStore.loginFromUserList?.length
                  ? SettingsStore.loginFromUserList?.map((eachLoginData) => {
                      return (
                        <div
                          className="username_details"
                          style={{
                            cursor: "pointer",
                            border: tempLoginFromCheckedIds?.[
                              eachLoginData.user.user_id
                            ]
                              ? "1px solid #c59331"
                              : "1px solid #dde2eb",
                          }}
                          onClick={() =>
                            handleUserSelection(
                              eachLoginData?.user?.user_id,
                              tempLoginFromCheckedIds?.[
                                eachLoginData.user.user_id
                              ]
                            )
                          }
                        >
                          <div className="username_details_left">
                            <input
                              className="checkbox"
                              type="checkbox"
                              checked={
                                tempLoginFromCheckedIds?.[
                                  eachLoginData.user.user_id
                                ]
                              }
                              onKeyDown={(e) => {
                                if (e.key === "Enter")
                                  handleUserSelection(
                                    eachLoginData?.user?.user_id,
                                    tempLoginFromCheckedIds?.[
                                      eachLoginData.user.user_id
                                    ]
                                  );
                              }}
                            />
                            {
                              //SettingsStore.recentLoginImages
                              // ?
                              SettingsStore.recentLoginImages?.[
                                eachLoginData?.user?.user_id
                              ] ? (
                                // : null
                                <img
                                  style={{ borderRadius: "14px" }}
                                  height={40}
                                  width={40}
                                  src={
                                    SettingsStore.recentLoginImages
                                      ? SettingsStore.recentLoginImages[
                                          eachLoginData?.user?.user_id
                                        ]
                                      : null
                                  }
                                  alt="user"
                                />
                              ) : (
                                <div className="single_no_image">
                                  <p>
                                    {" "}
                                    {
                                      eachLoginData?.user?.full_name.split(
                                        " "
                                      )[0][0]
                                    }
                                    {
                                      eachLoginData?.user?.full_name.slice(
                                        eachLoginData?.user?.full_name.lastIndexOf(
                                          " "
                                        ) + 1
                                      )[0]
                                    }
                                  </p>
                                </div>
                              )
                            }
                            <p className="username_text">
                              {eachLoginData?.user?.full_name}
                            </p>
                          </div>
                          {eachLoginData?.user?.manager && (
                            <div className="username_details_right">
                              <p className="role">{familyOfficeTeamNameText}</p>
                            </div>
                          )}
                        </div>
                      );
                    })
                  : null}
              </div>
            </div>
            <div className="by_devices_container">
              <p className="by_devices_text">By Devices</p>
              <div className="devices_cards">
                <div
                  className={`device_card ${
                    tempbyDevicesFilterSelected?.apple ? "golden_border" : ""
                  }`}
                  onClick={() =>
                    handleDeviceSelection(
                      {
                        ...tempbyDevicesFilterSelected,
                        apple: !tempbyDevicesFilterSelected?.apple,
                      },
                      "apple"
                    )
                  }
                >
                  <div className="device_icon">
                    <img src={appleIcon} alt="apple" />
                  </div>
                  <p className="device_type_text">Apple Devices</p>
                </div>
                <div
                  className={`device_card ${
                    tempbyDevicesFilterSelected?.android ? "golden_border" : ""
                  }`}
                  onClick={() =>
                    handleDeviceSelection(
                      {
                        ...tempbyDevicesFilterSelected,
                        android: !tempbyDevicesFilterSelected?.android,
                      },
                      "android"
                    )
                  }
                >
                  <div className="device_icon">
                    <img src={androidIcon} alt="android" />
                  </div>
                  <p className="device_type_text">Android Devices</p>
                </div>
                <div
                  className={`device_card ${
                    tempbyDevicesFilterSelected?.others ? "golden_border" : ""
                  }`}
                  onClick={() =>
                    handleDeviceSelection(
                      {
                        ...tempbyDevicesFilterSelected,
                        others: !tempbyDevicesFilterSelected?.others,
                      },
                      "others"
                    )
                  }
                >
                  <div className="device_icon">
                    <img src={otherDeviceIcon} alt="other devices" />
                  </div>
                  <p className="device_type_text">Others</p>
                </div>
              </div>
            </div>
            <div className="bottom_navigation">
              <button className="reset_button" onClick={handleReset}>
                Reset
              </button>
              <div
                className="apply_container"
                style={{ cursor: "pointer" }}
                onClick={handleApplyFilter}
              >
                <p className="apply_filter_text">Apply Filter</p>
                <button className="apply_filter_button">
                  <div className="arrow_wrapper">
                    <img src={rightArrowWhite} alt="arrow" />
                  </div>
                </button>
              </div>
            </div>
          </div>
        )}
      </Observer>
    );
  };

  const getIcon = (deviceType) => {
    switch (deviceType) {
      case "Android":
        return androidIcon;
      case "iOS":
        return appleIcon;
      case "Chrome":
        return otherDeviceIcon;
      default:
        return otherDeviceIcon;
    }
  };

  const openRemoveDeviceModal = (deviceId, deviceBuild, deviceType) => {
    setOpenModal(true);
    setSelectedDeviceForRemove({ deviceId, deviceBuild, deviceType });
  };

  const handleAddMore = () => {
    setViewMoreClicked(true);
    setRecentLoginArrLength(SettingsStore.recentLogin?.length);
  };

  const getFormattedDateTime = (dateTimeStr) => {
    if (dateTimeStr) {
      const [month, date, year, time] = dateTimeStr
        .split(" ")
        .filter((truthy) => truthy);
      const formattedTime = `${time.split(":")[0]}:${time.split(":")[1]} ${
        time.includes("AM") ? "AM" : "PM"
      }`;
      return `${formattedTime} • ${date} ${month} ${year.slice(2, 4)}`;
    } else return "";
  };

  const checkFilter = (eachLoginData) => {
    const enums = {
      Android: "android",
      iOS: "apple",
    };

    let data = "";

    if (eachLoginData?.devices?.deviceType in enums) {
      data = enums[eachLoginData?.devices?.deviceType];
    } else {
      data = "others";
    }
    if (
      SettingsStore.loginFromCheckedIds?.[eachLoginData?.user?.user_id] &&
      SettingsStore.byDevicesFilterSelected?.[data]
    ) {
      if (!isFilteredDataHasLength) {
        setIsFilteredDataHasLength(true);
      }
      return true;
    }
  };

  const getrowDataForRecentLogin = () => {
    const rowData = SettingsStore.recentLogin?.map((eachLoginData, index) => {
      if (checkFilter(eachLoginData)) {
        return (
          <li keey={index} className="listitem">
            <div className="name_wrapper">
              {(
                SettingsStore.recentLoginImages
                  ? SettingsStore.recentLoginImages[
                      eachLoginData?.user?.user_id
                    ]
                  : null
              ) ? (
                <img
                  style={{ borderRadius: "14px" }}
                  height={40}
                  width={40}
                  src={
                    SettingsStore.recentLoginImages
                      ? SettingsStore.recentLoginImages[
                          eachLoginData?.user?.user_id
                        ]
                      : null
                  }
                  alt="user"
                />
              ) : (
                <div className="single_no_image">
                  <p>
                    {" "}
                    {eachLoginData?.user?.full_name.split(" ")[0][0]}
                    {
                      eachLoginData?.user?.full_name.slice(
                        eachLoginData?.user?.full_name.lastIndexOf(" ") + 1
                      )[0]
                    }
                  </p>
                </div>
              )}
              <div className="name">
                <p className="name_text">
                  {eachLoginData?.user?.full_name || "-"}
                </p>
                {eachLoginData?.user?.manager && (
                  <p className="role">{familyOfficeTeamNameText}</p>
                )}
              </div>
            </div>
            <p className="device">
              {eachLoginData?.devices?.deviceBuild || " - "}
            </p>
            <p className="time_day">
              {getFormattedDateTime(eachLoginData?.lastLoginDateTime) || " - "}
            </p>
          </li>
        );
      } else {
        return null;
      }
    });
    const len = rowData.filter((eachRow) => eachRow).length;
    setFilteredArrayTotalLen(len);
    if (len) {
      if (len > 5) {
        setIsFilteredDataHasLength(true);
        if (!viewMoreClicked) {
          setRecentLoginArrLength(5);
        }
      } else setIsFilteredDataHasLength(false);

      return rowData
        .filter((eachRow) => eachRow)
        ?.slice(0, recentLoginArrLength);
    } else {
      setIsFilteredDataHasLength(false);
      return null;
    }
  };

  return (
    <Observer>
      {() => (
        <>
          {flag ? (
            <>
              <div className="manage_devices">
                {SettingsStore.registeredDevices && flag && (
                  <div className="current_devices_list">
                    <ul className="current_devices_list_container">
                      {SettingsStore.registeredDevices?.map(
                        (eachDevice, index) => (
                          <li
                            className="current_devices_listitem"
                            key={eachDevice?.deviceId}
                          >
                            <div className="device_text_icon_wrapper">
                              <div className="device_icon_wrapper">
                                <img
                                  src={getIcon(eachDevice?.deviceType)}
                                  alt="device"
                                />
                              </div>
                              <p className="device_info_text">
                                {eachDevice?.deviceType}
                                <span>{eachDevice?.deviceBuild}</span>
                              </p>
                            </div>
                            {eachDevice?.deviceId !==
                              UserStore.userDeviceId && (
                              <img
                                className="disable_icon clickable"
                                src={disableIcon}
                                alt="disable"
                                onClick={() =>
                                  openRemoveDeviceModal(
                                    eachDevice?.deviceId,
                                    eachDevice?.deviceBuild,
                                    eachDevice?.deviceType
                                  )
                                }
                              />
                            )}
                          </li>
                        )
                      )}
                    </ul>
                  </div>
                )}
                <div className="recent_login">
                  <div className="recent_login_header">
                    <div className="recent_login_heading">
                      <div className="recent_login_icon_wrapper">
                        <img src={recentLoginIcon} alt="recent" />
                      </div>
                      <p>Recent Login</p>
                    </div>
                    <button
                      className="recent_btn"
                      onClick={() => setOpenFilterModal(true)}
                    >
                      <img
                        className="filter_icon clickable"
                        src={filterIcon}
                        alt="filter"
                      />
                    </button>
                  </div>
                  <div className="recent_login_data">
                    <div className="recent_login_data_header">
                      <p className="name">Name</p>
                      <p className="device">Device</p>
                      <p className="time_day">Time & Day</p>
                    </div>
                    <div className="recent_login_data_listitems">
                      <ul className="listitem_container">
                        {SettingsStore.recentLogin?.length ? (
                          getrowDataForRecentLogin() || (
                            <EmptyDerivatives
                              image={emptyIcon}
                              message="No Records Found"
                            />
                          )
                        ) : (
                          <EmptyDerivatives
                            image={emptyIcon}
                            message="No Records Found"
                          />
                        )}
                      </ul>
                      {isFilteredDataHasLength &&
                      SettingsStore.recentLogin?.length &&
                      SettingsStore.recentLogin?.length - recentLoginArrLength >
                        0 ? (
                        <div
                          className="view_20_more"
                          onClick={handleAddMore}
                          style={{ cursor: "pointer" }}
                        >
                          {`View ${
                            // SettingsStore.recentLogin?.length -
                            filteredArrayTotalLen - recentLoginArrLength
                          } More`}

                          <img src={viewMoreIcon} alt="view more" />
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
              <Modal
                onClose={() => setOpenModal(false)}
                open={openModal}
                width="438px"
                minWidth="438px"
                modalContainerClass="disable_device_modal_container"
              >
                <DisableDeviceModalContent />
              </Modal>
              <Modal
                onClose={() => setOpenFilterModal(false)}
                open={openFilterModal}
                width="650px"
                minWidth="650px"
                title="Filters"
                modalContainerClass="filter_modal_container"
              >
                <FilterModalContent />
              </Modal>
            </>
          ) : (
            <div className="loader_container_manage">
              {" "}
              <img className="loading_gif2" src={loaderGIF} alt="loading..." />
            </div>
          )}
        </>
      )}
    </Observer>
  );
};

export default ManageDevices;
